<div class="flex flex-col w-full">
  <!-- <span class="text-[]">{{ tableTitle }}</span> -->
  <div class="w-full h-full min-h-[calc(100vh-250px)]">
    <div class="flex justify-between w-full items-center">
      <span *ngIf="!toolbar?.paginate" class="max-sm:hidden"></span>
      <div
        *ngIf="toolbar?.paginate"
        class="max-sm:hidden flex items-center gap-[11px] text-[14px] text-[#4B5563]"
      >
        <span>showing</span>
        <div
          (click)="toggleLimit()"
          class="flex relative w-[73px] realtive h-[28px] justify-center cursor-pointer items-center text-[14px] text-[#EDEEFF] bg-[#081A46] rounded-[3px]"
        >
          {{
            paginationData.totalData && paginationData.totalData > currentLimit
              ? currentLimit
              : paginationData.totalData
          }}
          <img
            src="../../../../assets/icons/light-chevron.svg"
            class="w-[24px] h-[24px]"
            alt=""
          />
          <div
            *ngIf="
              paginationData.totalData > paginationData.limit && showLimits
            "
            class="flex flex-col absolute top-[28px] w-full text-[gray] bg-gray-50"
          >
            <span
              *ngIf="paginationData.totalData > 29"
              (click)="selectLimit(30)"
              class="w-full flex items-center h-[25px] cursor-pointer justify-center shadow-sm"
              >30
            </span>
            <span
              *ngIf="paginationData.totalData > 39"
              (click)="selectLimit(40)"
              class="w-full flex items-center h-[25px] cursor-pointer justify-center shadow-sm"
              >40
            </span>
            <span
              *ngIf="paginationData.totalData > 49"
              (click)="selectLimit(50)"
              class="w-full flex items-center h-[25px] cursor-pointer justify-center shadow-sm"
              >50
            </span>
          </div>
        </div>
        <span>of {{ paginationData.totalData }}</span>
      </div>

      <div
        class="flex items-center gap-[24px] sm:justify-end justify-between sm:w-fit w-full"
      >
        <div class="flex items-center gap-[24px]">
          <app-search-item
            *ngIf="toolbar?.search"
            (searchItem)="searchAccount($event)"
          ></app-search-item>
          <span
            *ngIf="
              (toolbar?.search && toolbar?.filter) ||
              (toolbar?.search && toolbar?.addnew)
            "
            class="w-[1px] h-[37px] bg-[#E5E7EB]"
          ></span>
          <app-filter
            *ngIf="toolbar?.filter"
            [data]="filterData"
            (filterChanged)="applyFilter($event)"
          ></app-filter>
        </div>
        <span
          *ngIf="toolbar?.addnew"
          (click)="addData()"
          class="flex whitespace-nowrap items-center gap-[4px] px-[24px] py-[12px] bg-[#081A46] rounded-[6px] cursor-pointer text-[14px] text-[#fff]"
        >
          <img
            *ngIf="addNewDataText !== 'Configure'"
            src="../../../../assets/icons/plus-light.svg"
            alt=""
            class="sm:block hidden"
          />
          {{ addNewDataText }}
        </span>
      </div>
    </div>

    <div class="w-full overflow-x-auto">
      <div class="w-full  flex flex-col gap-[4px] mt-[41px] {{ tableWidth }}">
        <div
          *ngIf="
            tableData.length > 0 &&
            tableData[0].length > 0 &&
            tableData[0][0]?.name &&
            !loading
          "
          class="flex w-full h-[41px] gap-[32px] items-center bg-[#F4F5F7] justify-between px-[24px] pl-[17px]"
        >
          <span
            class="text-[11px] text-[#374151] uppercase font-[800] whitespace-nowrap"
            style.minWidth="{{ tableHeader[0]?.ratio?.minWidth }}"
            style.width="{{
              tableHeader &&
                tableHeader.length > 0 &&
                tableHeader[0]?.ratio?.width
            }}"
          >
            {{ tableHeader[0]?.name }}
          </span>
          <span
            class="text-[11px] text-[#374151] uppercase font-[800] whitespace-nowrap"
            *ngFor="let tag of tableHeader?.slice(1)"
            style.width="{{ tag?.ratio.width }}"
            style.minWidth="{{ tag?.ratio.minWidth }}"
            >{{ tag?.name }}</span
          >
        </div>

        <div
          class="w-full"
          *ngIf="
            tableData.length > 0 &&
            tableData[0].length > 0 &&
            tableData[0][0]?.name &&
            !loading
          "
        >
          <div
            *ngFor="let data of tableData"
            class="flex w-full h-[84px] gap-[32px] relative items-center border-b-[1.3px] justify-between px-[24px] pl-[17px] hover:bg-[#fafaf9] cursor-pointer"
          >
            <div
              class="overflow-hidden h-full flex items-center"
              (click)="viewRow(data[0].id)"
              style.minWidth="{{
                data && data.length > 0 && data[0]?.ratio
                  ? data[0]?.ratio?.minWidth
                  : '10%'
              }}"
              style.width="{{
                data && data?.length > 0 && data[0]?.ratio
                  ? data[0]?.ratio?.width
                  : '10%'
              }}"
            >
              <app-avatar-profile
                [styles]="{
                boxColor: '#EDEEFF',
                boxHeight: '40px',
                boxWidth: '40px',
              }"
                [title]="data?.length > 1 ? data[0]?.name?.title : ''"
                [label]="
                  data?.length > 1 && data[0]?.name?.label
                    ? data[0]?.name?.label
                    : ''
                "
              >
                <div *ngIf="data">
                  <span *ngIf="!data[0]?.name?.icon" style="color: #000">
                    {{ data[0]?.name?.title[0] }}
                  </span>
                  <img
                    *ngIf="data[0]?.name?.icon"
                    src="{{ data[0]?.name?.icon }}"
                  />
                </div>
              </app-avatar-profile>
            </div>

            <span
              *ngFor="let row of getSlicedData(data?.slice(1))"
              [innerHTML]="row?.name?.title"
              class="text-[12px] text-[#374151] font-[400] text-wrap h-full flex items-center"
              (click)="viewRow(row.id)"
              style.width="{{ row && row?.ratio ? row?.ratio?.width : '10%' }}"
              style.minWidth="{{
                row && row?.ratio ? row?.ratio?.minWidth : '10%'
              }}"
            >
            </span>
            <span
              *ngIf="hasModalFunction && !useRowLoader && data"
              (click)="openModal(data[data?.length - 1].id)"
              style.width="{{ data[data?.length - 1].ratio?.width }}"
              style.minWidth="{{ data[data?.length - 1].ratio?.minWidth }}"
              class="text-[12px] z-[999999] h-full flex items-center justify-center text-[#374151] font-[400] whitespace-nowrap"
              [innerHTML]="data[data?.length - 1].name?.title"
            ></span>
            <span
              *ngIf="
                hasModalFunction &&
                useRowLoader &&
                data &&
                indexId === data[data.length - 1].id
              "
              style.width="{{ data[data.length - 1].ratio?.width }}"
              style.minWidth="{{ data[data.length - 1].ratio?.minWidth }}"
              class="text-[12px] z-[999999] min-w-[80px] h-full flex items-center justify-center text-[#374151] font-[400] whitespace-nowrap"
              [innerHTML]="data[data.length - 1].name?.loader"
            >
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-[16px] w-full" *ngIf="loading">
          <div *ngFor="let n of [0, 1, 3]" class="flex w-full gap-[32px]">
            <span
              *ngFor="let i of ['25%', '25%', '25%', '25%']"
              [style.width]="i"
            >
              <div class="w-full bg-slate-100 h-[35px] animate-pulse"></div>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        (tableData.length === 0 && !loading) ||
        (tableData.length > 0 && tableData[0].length < 0 && !loading) ||
        (tableData.length > 0 &&
          tableData[0].length > 0 &&
          !tableData[0][0]?.name &&
          !loading)
      "
      class="w-full h-full min-h-[400px] flex justify-center items-center"
    >
      <div
        class="flex flex-col gap-[17px] items-center justify-center max-w-[334px]"
      >
        <img
          class="h-[162px] w-fit"
          src="../../../../assets/images/empty.svg"
          alt=""
        />
        <div class="flex flex-col gap-[7px] mt-[7px]">
          <span class="text-center text-[16px] font-[800] text-[#364152]">{{
            emptyState?.title
          }}</span>
          <span class="text-center text-[14px] font-[400] text-[#6B7280]"
            >{{ emptyState?.label }}
          </span>
        </div>
        <span
          *ngIf="emptyState?.btnText && emptyState?.btnText !== ''"
          (click)="addData()"
          class="flex items-center justify-center cursor-pointer text-[#fff] text-[14px] font-[500] bg-[#081A46] h-[40px] rounded-[6px] w-[202px]"
          >{{ emptyState?.btnText }}</span
        >
      </div>
    </div>
  </div>
</div>
<div class="flex flex-wrap gap-x-[50px] items-center justify-between w-full">
  <div
    *ngIf="toolbar?.paginate"
    class="sm:hidden mt-3 flex items-center gap-[11px] text-[14px] text-[#4B5563]"
  >
    <span>showing</span>
    <div
      class="flex relative w-[73px] h-[28px] justify-center cursor-pointer items-center text-[14px] text-[#EDEEFF] bg-[#081A46] rounded-[3px]"
    >
      20
      <img
        src="../../../../assets/icons/light-chevron.svg"
        class="w-[24px] h-[24px]"
        alt=""
      />
    </div>
    <span class="whitespace-nowrap">of 20</span>
  </div>
  <ng-content></ng-content>
</div>
